var __jsx = React.createElement;
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import Waffles, { useKeyboardNavigation, useVerticalScrollingNavigation } from '@pelotoncycle/waffles';
import React from 'react';
import { isOk } from '@engage/result';
import { AgeGateModal } from '@webtv/age-gate';
import { useIsLoggedIn, useLogout, LogoutEvent, useOauthEnabled } from '@webtv/auth';
import { ContractAgreementsTakeover } from '@webtv/contract-agreements';
import { useAuthorizationHeader, useLastSelectedTerm } from '@webtv/data-fetch';
import { engageApi } from '@webtv/data-fetch/singletons';
import { hasCapability } from '@webtv/devices';
import { PELOTON_PLATFORM } from '@webtv/env';
import { captureException } from '@webtv/error-reporting-v2';
import { OptimizelyFeature, isExperimentEnabled } from '@webtv/feature-toggles';
import { FiltersProvider } from '@webtv/filters/ui/contexts';
import { GlobalStyles, lowCapabilityClass } from '@webtv/global-styles';
import { SyncWafflesNavWithVirtualKeyboard } from '@webtv/keyboard-visibility';
import { TermsTakeover } from '@webtv/terms';
import { PageStyles } from './PageStyles';
/**
 * The base wrapper for Web TV apps which includes global styling (fonts)
 * and the base context for `waffles` navigation.
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var PageShell = function PageShell(_ref) {
  var children = _ref.children;
  var oauthEnabled = useOauthEnabled();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(GlobalStyles, {}), /*#__PURE__*/_jsx(PageStyles, {}), /*#__PURE__*/_jsx(OauthErrorHandler, {}), oauthEnabled && /*#__PURE__*/_jsx(AuthorizationHeader, {}), /*#__PURE__*/_jsx(LastSelectedTerm, {}), /*#__PURE__*/_jsx(FiltersProvider, {
      children: /*#__PURE__*/_jsx(CPUCapabilities, {
        className: cx(hasCapability('cpu', 'low') && lowCapabilityClass),
        children: /*#__PURE__*/_jsxs(Waffles, {
          children: [/*#__PURE__*/_jsx(KeyboardNavigation, {}), PELOTON_PLATFORM === 'lg' && /*#__PURE__*/_jsx(ScrollNavigation, {}), /*#__PURE__*/_jsx(SyncWafflesNavWithVirtualKeyboard, {}), /*#__PURE__*/_jsx(TermsTakeoverFork, {
            children: /*#__PURE__*/_jsx(AgeGateModal, {
              children: children
            })
          })]
        })
      })
    })]
  });
};

var TermsTakeoverFork = function TermsTakeoverFork(_ref2) {
  var children = _ref2.children;
  var shouldUseNewTakeover = isExperimentEnabled(OptimizelyFeature.PrivacyUpdates);

  if (shouldUseNewTakeover) {
    return /*#__PURE__*/_jsx(ContractAgreementsTakeover, {
      children: children
    });
  }

  return /*#__PURE__*/_jsx(TermsTakeover, {
    children: children
  });
};

var CPUCapabilities = /*#__PURE__*/styled("div")({
  name: "CPUCapabilities",
  class: "ckdqdpa"
});

var KeyboardNavigation = function KeyboardNavigation() {
  useKeyboardNavigation();
  return null;
};

var ScrollNavigation = function ScrollNavigation() {
  useVerticalScrollingNavigation();
  return null;
};

var AuthorizationHeader = function AuthorizationHeader() {
  useAuthorizationHeader(engageApi.axios);
  return null;
};

var LastSelectedTerm = function LastSelectedTerm() {
  useLastSelectedTerm();
  return null;
};

var OauthErrorHandler = function OauthErrorHandler() {
  var _useIsLoggedIn = useIsLoggedIn(),
      isLoggedIn = _useIsLoggedIn.isLoggedIn;

  var logout = useLogout(engageApi, LogoutEvent.OauthErrorHandler);
  React.useEffect(function () {
    if (isOk(isLoggedIn) && isLoggedIn.value) {
      engageApi.axios.interceptors.response.use(function (config) {
        if (config.headers['invalidate-token'] === 'True') {
          captureException('Token mismatch detected');
          logout();
        }

        return config;
      });
    }
  }, [logout, isLoggedIn]);
  return null;
};

require("../../../apps/tv/.linaria-cache/packages/@webtv/layout/PageShell.linaria.module.css");